export default __webpack_public_path__ + "static/media/sunriseEmoji.86dd1963.png";